import React from 'react'
import MaterialSymbol from '../material-symbol'

const NoteAdd = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="note_add" {...props} />
))

NoteAdd.displayName = 'NoteAdd'

export default NoteAdd
